import { render } from "./RightSidebar.vue?vue&type=template&id=2c7c50a9&scoped=true"
import script from "./RightSidebar.vue?vue&type=script&lang=js"
export * from "./RightSidebar.vue?vue&type=script&lang=js"

import "./RightSidebar.vue?vue&type=style&index=0&id=2c7c50a9&scoped=true&lang=css"
import "./RightSidebar.vue?vue&type=style&index=1&id=2c7c50a9&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7c50a9"]])

export default __exports__